module.exports = __webpack_public_path__ + "static/img/main3.a906fd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/main3.png
// module id = VT7/
// module chunks = 1